// extracted by mini-css-extract-plugin
var _1 = "FunFact-module__did___f7Nk2";
var _2 = "FunFact-module__fact___ZJBaz";
var _3 = "FunFact-module__line___eGp2t";
var _4 = "FunFact-module__threex___GfoiU";
export { _1 as "did", _2 as "fact", _3 as "line", _4 as "threex" }
